import { useEffect } from 'react';
import { useTestStore } from '../store/testStore';
import { migrateHistoryEntries } from '../utils/historyMigration';

/**
 * This hook migrates any test history entries that don't have dates.
 * It should be used in the top-level component of the application.
 */
export const useMigrateTestHistory = () => {
  useEffect(() => {
    try {
      // Read once inside the effect instead of subscribing — a subscription
      // here (above the route Suspense boundary) forces prerendered pages to
      // client-render during hydration (React error #421).
      const { history } = useTestStore.getState();
      if (history && history.length > 0) {
        // Check if any history entries are missing the date property
        const needsMigration = history.some(entry => !entry.date || !entry.id);

        if (needsMigration) {
          const migratedHistory = migrateHistoryEntries(history);

          // Update the store with the migrated history
          // We're accessing the internal state here, which is not ideal
          // but necessary for this migration
          useTestStore.setState({ history: migratedHistory });
        }
      }
    } catch (error) {
      console.error('Error during test history migration:', error);
      // Don't throw - just log the error and continue
    }
  }, []);

  return null;
};

export default useMigrateTestHistory;